import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { UserSessionService } from '@core/services/user-session';
import { APP_ROUTES } from '@shared/common';
import { UserRole } from 'jplus-design-system-angular';
import { filter, map, take } from 'rxjs';

export const projectBriefingGuard: CanActivateFn = route => {
  const userSessionService = inject(UserSessionService);

  return userSessionService.user$.pipe(
    filter(user => !!user),
    take(1),
    map(user => {
      if (user.role === UserRole.Jellyfish) {
        return true;
      }

      if (user.role === UserRole.Client) {
        return createUrlTreeFromSnapshot(route, ['../', APP_ROUTES.clientOverview]);
      }

      return false;
    })
  );
};
